<template>
  <div>
    <div
      class="wizard-overlay"
      :class="{activated: activated, 'bg--blue': theme === 'default', 'bg--green': theme === 'green', 'bg--gray': theme === 'gray'}">
      <slot/>
    </div>
    <div
      class="bg-overlay"
      v-if="activated"/>
  </div>
</template>

<script>
export default {
  name: 'WizardOverlayContainer',
  props: {
    activated: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: 'default'
    }
  }
}
</script>

<style scoped lang="less">
@import '~@/variables.less';
.wizard-overlay {
  width: 95%;
  max-width: 95%;
  padding: 24px 36px;
  margin: 0 auto;
  border: 1px solid #ddd;
  border-radius: 10px;
  position: relative;
  transition: all 0.5s;

  &.bg--blue {
    background: @blueLight;
  }

  &.bg--green {
    background: @libraryColorBg;
  }

  &.bg--gray {
    background: #f5f5f5;
  }

  &.activated {
    z-index: 1002;
    box-shadow: 0 0 60px 8px rgba(0, 0, 0, 0.4);
    margin-top: -10px;
    margin-bottom: 10px;
  }

  .close-button {
    color: black;
    opacity: 0.5;
    &:hover {
      opacity: 0.7;
    }
    float: right;
    cursor: pointer;
  }
}
.bg-overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: black;
  opacity: 0.55;
  z-index: 1001;
}
</style>